import {
  getComponentCssUrl,
  getGlobalCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavHeaderPrimaryTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavHeaderPrimary--wc.css')}" rel="stylesheet" />
`
  return t
}

// Getter function for template
const getTemplateNavHeaderPrimaryStyles = () => createNavHeaderPrimaryTemplate()
export { getTemplateNavHeaderPrimaryStyles }
